<template>
  <div class="tags-box">
    <el-dialog
      :title="'图集详情'"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="picturePopup" @dragover="dragover($event)">
        <transition-group class="transition-wrapper" name="sort">
          <div
            class="comicsPreview"
            v-for="(item, i) in pics"
            :key="item"
            :a="item"
            :draggable="true"
            @dragstart="dragstart(item)"
            @dragenter="dragenter(item, $event)"
            @dragover="dragover($event)"
            @dragend="dragend(item, $event)"
          >
            <img-load
              :width="'100px'"
              :height="'100px'"
              :src="imgUrl + item"
            ></img-load>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              class="delBtn"
              @click="deletePicture(i)"
            ></el-button>
          </div>
        </transition-group>
        <base-upload
          :action="action"
          @successCallback="successCallbackAdd"
          :wSize="100"
          :hSize="100"
          :width="'100px'"
          :height="'100px'"
          :hide="true"
          :multiple="true"
        ></base-upload>
      </div>
      <div class="subTitle">手动拖拽改变图片顺序，切记要确定哦～</div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          class="submitBtn"
          @click="submitDate()"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
import local from "@/utils/localStroage";

export default {
  data() {
    return {
      id: "",
      tags: [],
      flag: false,
      dialogVisible: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      imgUrl: baseConfig.imgUrl,
      pics: [],
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      header: {
        Authorization: local.get("userInfo").token,
      },
      oldData: {},
      newData: {},
    };
  },
  methods: {
    // 封面图上传成功回调
    successCallback(res) {
      if (!this.pics) {
        this.pics = [];
      }
      this.pics = this.pics.concat(res.data.filePath);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    editVideoInfo(params) {
      API.editVideoInfo(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.$emit("handlerPreviewList");
          } else {
            this.$message.error("操作失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 打开弹窗并初始化tags数据
    open(pictureArr, id, tags) {
      this.id = id;
      this.tags = tags.map((el) => el.name);
      this.pics = pictureArr || [];
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.fileList = [];
      this.pics = undefined;
    },
    // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    dragover(e) {
      e.preventDefault();
    },
    dragstart(value) {
      this.oldData = value;
    },
    // 记录移动过程中信息
    dragenter(value, e) {
      this.newData = value;
      e.preventDefault();
    },
    // 拖拽最终操作
    dragend() {
      if (this.oldData !== this.newData) {
        let oldIndex = this.pics.indexOf(this.oldData);
        let newIndex = this.pics.indexOf(this.newData);
        let newItems = [...this.pics];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, this.oldData);
        this.pics = [...newItems];
      }
    },
    // 新增图片上传成功回调
    successCallbackAdd(res) {
      this.pics.push(res.data.coverImg);
    },
    // 删除某张图片
    deletePicture(i) {
      this.pics.splice(i, 1);
    },
    // 提交表单
    submitDate() {
      this.editVideoInfo({
        seriesCover: this.pics,
        id: this.id,
        tags: this.tags,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.tags-box {
  .el-dialog {
    padding: 0 !important;
    margin: 0 !important;
  }
  .input-box {
    margin-top: 15px;
    text-align: left;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
  }
  .subTitle {
    font-size: 13px;
    font-weight: 500;
    color: red;
  }
  .picturePopup {
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-height: 580px;
    .transition-wrapper {
      display: flex;
      flex-wrap: wrap;
      .comicsPreview {
        margin-right: 20px;
        margin-bottom: 20px;
        position: relative;
        .delBtn {
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 120px;
  }
}
.submitBtn {
  padding: 9px 15px;
}
</style>
